export const routes = [
    {
        path: '/',
        redirect: "/login",
        meta: {
            show: false, //判断是否展示菜单栏
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/login'),
        meta: {
            title: "登录",
            show: false,
        },
    },
    {
        path: '/customer',
        name: 'customer',
        component: () => import('@/pages/common'),
        meta: {
            title: "客户管理",
            icon: "el-icon-user",
            show: true,
        },
        children: [
            {
                path: 'list',
                name: 'customer-list',
                component: () => import('@/pages/customer/list'),
                meta: {
                    title: "客户列表",
                    show: true,
                },
            },
            {
                path: 'dealer',
                name: 'customer-dealer',
                component: () => import('@/pages/customer/dealer'),
                meta: {
                    title: "经销商列表",
                    show: true,
                },
            },
            {
                path: 'details',
                name: 'customer-details',
                component: () => import('@/pages/customer/details'),
                meta: {
                    title: "客户详情",
                    show: false,
                },
            },
        ]
    },
    {
        path: '/property',
        name: 'property',
        component: () => import('@/pages/common'),
        meta: {
            title: "资产管理",
            icon: "el-icon-truck",
            show: true,
        },
        children: [
            {
                path: 'list',
                name: 'property-list',
                component: () => import('@/pages/property/list'),
                meta: {
                    title: "资产列表",
                    show: true,
                },
            },
            {
                path: 'details',
                name: 'property-details',
                component: () => import('@/pages/property/details'),
                meta: {
                    title: "资产详情",
                    show: false,
                },
            },
            {
                path: 'car',
                name: 'property-car',
                component: () => import('@/pages/property/car'),
                meta: {
                    title: "车辆状况",
                    show: true,
                },
            },
            {
                path: 'car-type-manage',
                name: 'property-car-type-manage',
                component: () => import('@/pages/property/car-type-manage'),
                meta: {
                    title: "车型管理",
                    show: true,
                },
            }
        ]
    },
    {
        path: '/delivery',
        name: 'delivery',
        component: () => import('@/pages/common'),
        meta: {
            title: "交付管理",
            icon: "el-icon-date",
            show: true,
        },
        children: [
            {
                path: 'list',
                name: 'delivery-list',
                component: () => import('@/pages/delivery/list'),
                meta: {
                    title: "交付列表",
                    show: true,
                },
            },
        ]
    },
    {
        path: '/audit',
        name: 'audit',
        component: () => import('@/pages/common'),
        meta: {
            title: "审批中心",
            icon: "el-icon-circle-check",
            show: true,
        },
        children: [
            {
                path: 'start',
                name: 'audit-start',
                component: () => import('@/pages/audit/start'),
                meta: {
                    title: "发起申请",
                    show: true,
                },
            },
            {
                path: 'my',
                name: 'audit-my',
                component: () => import('@/pages/audit/my'),
                meta: {
                    title: "待我审批",
                    show: true,
                },
            },
            {
                path: 'list',
                name: 'audit-list',
                component: () => import('@/pages/audit/list'),
                meta: {
                    title: "审批进度",
                    show: true,
                },
            }
        ]
    },
    {
        path: '/workorder',
        name: 'workorder',
        component: () => import('@/pages/common'),
        meta: {
            title: "服务管理",
            icon: "el-icon-s-order",
            show: true,
        },
        children: [
            {
                path: 'afterSale',
                name: 'workorder-afterSale',
                component: () => import('@/pages/workorder/after-sale/index.vue'),
                meta: {
                    title: "售后工单",
                    show: true,
                },
            },
            {
                path: 'recharge',
                name: 'workorder-recharge',
                component: () => import('@/pages/workorder/recharge/index.vue'),
                meta: {
                    title: "续费订单",
                    show: false,
                },
            }
        ]
    },
    {
        path: '/carDrive',
        name: 'carDrive',
        component: () => import('@/pages/common'),
        meta: {
            title: "智驾系统管理",
            icon: "el-icon-stopwatch",
            show: true,
        },
        children: [
            {
                path: '/map/list',
                name: 'map-list',
                component: () => import('@/pages/map/list'),
                meta: {
                    title: "地图管理",
                    show: true,
                },
            },
            {
                path: '/task/list',
                name: 'task-list',
                component: () => import('@/pages/task'),
                meta: {
                    title: "任务管理",
                    show: true,
                },
            },
            {
                path: '/task/detail',
                name: 'task-detail',
                component: () => import('@/pages/task/detail'),
                meta: {
                    title: "任务详情",
                    show: false,
                },
            },
            {
                path: '/trigger/list',
                name: 'trigger-list',
                component: () => import('@/pages/triggers'),
                meta: {
                    title: "事件管理",
                    show: true,
                },
            },
            {
                path: '/ota/list',
                name: 'ota-list',
                component: () => import('@/pages/ota/list'),
                meta: {
                    title: "软件管理",
                    show: true,
                },
            },
            {
                path: '/carVersion/list',
                name: 'carVersion-list',
                component: () => import('@/pages/carVersion/list'),
                meta: {
                    title: "软件版本",
                    show: true,
                },
            },
            {
                path: '/carVersion/chart',
                name: 'carVersion-chart',
                component: () => import('@/pages/carVersion/chart'),
                meta: {
                    title: "版本图表",
                    show: false,
                },
            },
            {
                path: '/calibration/list',
                name: 'calibration-list',
                component: () => import('@/pages/calibration/list'),
                meta: {
                    title: "标定数据",
                    show: true,
                },
            },
            {
                path: '/dashboard/board',
                name: 'dashboard-board',
                component: () => import('@/pages/dashboard/board'),
                meta: {
                    title: "日度统计",
                    show: true,
                },
            },
            {
                path: '/dashboard/chart',
                name: 'dashboard-chart',
                component: () => import('@/pages/dashboard/chart'),
                meta: {
                    title: "图表统计",
                    show: true,
                },
            },
            {
                path: '/log',
                name: 'log',
                component: () => import('@/pages/log'),
                meta: {
                    title: "日志管理",
                    show: true,
                },
            }

        ],
    },
    {
        path: '/map',
        name: 'map',
        component: () => import('@/pages/common'),
        meta: {
            title: "地图管理",
            icon: "el-icon-map-location",
            show: false,
        },
        children: [
            {
                path: 'add',
                name: 'map-add',
                component: () => import('@/pages/map/add'),
                meta: {
                    title: "地图创建",
                    show: false,
                },
            },
            {
                path: 'details',
                name: 'map-details',
                component: () => import('@/pages/map/details'),
                meta: {
                    title: "地图详情",
                    show: false,
                },
            },
            {
                path: 'release',
                name: 'map-release',
                component: () => import('@/pages/map/release'),
                meta: {
                    title: "地图推送",
                    show: false,
                },
            },
        ]
    },
    {
        path: '/ota',
        name: 'ota',
        component: () => import('@/pages/common'),
        meta: {
            title: "OTA管理",
            icon: "el-icon-user",
            show: false,
        },
        children: [

            {
                path: 'details',
                name: 'ota-details',
                component: () => import('@/pages/ota/details'),
                meta: {
                    title: "软件详情",
                    show: false,
                },
            },
        ]
    },
    // {
    //     path: '/dashboard',
    //     name: 'dashboard',
    //     component: () => import('@/pages/common'),
    //     meta: {
    //         title: "仪表盘",
    //         icon: "el-icon-data-board",
    //         show: true,
    //     },
    //     children: [
    //         {
    //             path: 'board',
    //             name: 'dashboard-board',
    //             component: () => import('@/pages/dashboard/board'),
    //             meta: {
    //                 title: "日度统计",
    //                 show: true,
    //             },
    //         },
    //         {
    //             path: 'chart',
    //             name: 'dashboard-chart',
    //             component: () => import('@/pages/dashboard/chart'),
    //             meta: {
    //                 title: "图表统计",
    //                 show: true,
    //             },
    //         }
    //     ]
    // },
    {
        path: '/account',
        name: 'account',
        component: () => import('@/pages/common'),
        meta: {
            title: "账号管理",
            icon: "el-icon-lock",
            show: true,
        },
        children: [
            {
                path: 'list',
                name: 'account-list',
                component: () => import('@/pages/account/list'),
                meta: {
                    title: "账号列表",
                    show: true,
                },
            },
            {
                path: 'permission',
                name: 'account-permission',
                component: () => import('@/pages/account/permission'),
                meta: {
                    title: "权限管理",
                    show: true,
                },
            },
        ]
    },
]


// WEBPACK FOOTER //
// ./src/router/router.config.js